export class ScheduledPatientHealthcareAgreementStruct {
    public nameHealthcareAgreement: string;
    public planName: string;
    public idHealthcareAgreement: number;
    public idPlan: number;
    public healthcareAgreementCardNumber: string;
    public healthcareAgreementExpirationDate: Date;
}